<template>
    <div class="right-content">
        <el-button type="text" class="right-content-btn right-content-profile">
            <img src="@images/avatar.png"/>
            超级管理员 · {{profile.name}}
        </el-button>
        <span class="right-content__divider">|</span>
        <el-button type="text" class="right-content-btn exit-btn" @click="handleLogout">退 出 <img src="@images/logout.png"/></el-button>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    name: 'TheRightContent',
    computed: {
         ...mapState({
             profile:state=>state.user.profile
         })
    },
    methods: {
        ...mapMutations('system', ['removeToken']),
        async handleLogout() {
            this.removeToken();
            const { href } = this.$router.resolve({ name: 'Login' });
            location.href = href;
        }
    }
};
</script>

<style lang="scss" scoped>
.right-content__divider,
.right-content-btn {
    padding: 0 12px;
    font-size: 16px;
    color: #333;
    img{vertical-align: middle;}
}
.right-content-profile{
    font-weight: bold;
}
.exit-btn{color: #FF3A30;}
</style>
